
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React from 'react';
import BasePageLayout from '#layouts/BasePageLayout/BasePageLayout';
import HeroUnit from '#components/sections/hero-unit/HeroUnit';
import HeroButtonParade from '#components/hero-button-parade/HeroButtonParade';
import HeroTabs from '#components/common/heroTabs/HeroTabs';
import Recommendations from '#components/common/recommendations/Recommendations';
import SocialMeta from '#components/common/meta/SocialMeta';
import VisibilityVerificationWrapper from '#components/layout/VisibilityVerificationWrapper';
import { ContentType, MediaType } from '#types/generated/graphql-types';
import MediaPreviewHeroButton from '#components/media-preview-hero-button/MediaPreviewHeroButton';
import {
  GetAnnouncementDocument,
  GetMediaPageDocument,
  GetNavigationDocument,
  useGetMediaPageQuery,
} from '#types/generated/apollo-client';
import { getRoute } from '#utils';
import useTranslation from 'next-translate/useTranslation';
import initializeClient from '#providers/apollo/initializeClient';
import addApolloState from '#providers/apollo/addApolloState';
import inPreviewMode from '#utils/inPreviewMode';
import { useRouter } from 'next/router';

const MediasDetail = ({ slug }) => {
  const { t } = useTranslation();
  const { asPath: url } = useRouter();
  const { data } = useGetMediaPageQuery({
    variables: { slug, contentType: ContentType.Video },
    fetchPolicy: 'cache-only',
    skip: !slug,
  });

  if (!data?.mediaBySlug) {
    return null;
  }

  const media = data.mediaBySlug;
  const studioUrl = getRoute(media?.studio, t);

  const previewMode = inPreviewMode(url);
  if (
    !previewMode &&
    [MediaType.Extra, MediaType.Trailer].includes(media.mediaType)
  ) {
    return null;
  }

  return (
    <BasePageLayout>
      <SocialMeta
        about={{
          title: media?.title,
          description: media?.teaserDescription,
          image: media?.backgroundImageFormats.sixteenByNine.large,
          type: 'video.movie',
        }}
      />

      <VisibilityVerificationWrapper reason={media?.products?.access?.reason} mediaIri={media?.iri}>
        <main className="page-main-container">
          <HeroUnit
            backgroundImageFormats={media?.backgroundImageFormats}
            categories={media?.categories}
            description={media?.shortDescription}
            fskRating={media?.fskRating}
            mediaQuality={media?.mediaQuality}
            mediaDuration={media?.mediaDuration}
            studioLogoImage={media?.studio?.logoImageFormats?.oneByOne?.small}
            studioName={media?.studio?.title}
            studioUrl={studioUrl}
            subtitle={media?.leadin}
            title={media?.title}
            titleImage={media?.logoImageFormats?.sixteenBySeven?.medium}
            year={media?.year}
            brandLogoImage={media?.logoImageFormats?.oneByOne?.medium}
            tags={media?.tags}
            buttonComponent={
              media.mediaType === MediaType.Extra ||
              media.mediaType === MediaType.Trailer ? (
                <MediaPreviewHeroButton
                  mediaIri={media.iri}
                  contentType={ContentType.Video}
                />
              ) : (
                <HeroButtonParade mediaIri={media.iri} media={media} />
              )
            }
          />
          <HeroTabs extras={media.extras} mediaDescription={media.description} media={media} />
          <Recommendations items={media.recommendations} />
        </main>
      </VisibilityVerificationWrapper>
    </BasePageLayout>
  );
};

 async function _getServerSideProps(context) {
  const slug = context.query.slug as string;
  const client = initializeClient({
    context,
  });

  //fetch page data
  const queries = await Promise.allSettled([
    client.query({
      query: GetMediaPageDocument,
      variables: { slug, contentType: ContentType.Video },
    }),
    client.query({
      query: GetAnnouncementDocument,
    }),
    client.query({
      query: GetNavigationDocument,
      variables: { name: 'Main' },
    }),
    client.query({
      query: GetNavigationDocument,
      variables: { name: 'Footer' },
    }),
    client.query({
      query: GetNavigationDocument,
      variables: { name: 'Profile' },
    }),
  ]);

  const pageResult = queries[0];

  if (
    pageResult.status !== 'fulfilled' ||
    !pageResult?.value?.data?.mediaBySlug
  ) {
    return {
      notFound: true,
    };
  }

  const media = pageResult.value.data.mediaBySlug;
  const previewMode = inPreviewMode(context?.resolvedUrl);

  if (
    !previewMode &&
    [MediaType.Extra, MediaType.Trailer].includes(media.mediaType)
  ) {
    return {
      notFound: true,
    };
  }

  return addApolloState(client, { props: { slug } });
}

export default MediasDetail;


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/movies/[slug]',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  